import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/images/aio/wrong-data.png'


const _withScopeId = (n: any) => (_pushScopeId("data-v-48546d08"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrong-page-content" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "页面出问题了，请点击重试", -1))
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ActionBar = _resolveComponent("ActionBar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($props.showActionBar)
      ? (_openBlock(), _createBlock(_component_ActionBar, {
          key: 0,
          onGoBack: $setup.goBack,
          actionBarInfo: $setup.actionBarInfo,
          needShare: false
        }, null, 8, ["onGoBack", "actionBarInfo"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.clickRefresh && $setup.clickRefresh(...args))),
      class: "content"
    }, _hoisted_4)
  ]))
}